var map = {
	"./401_images/401.gif": "./src/assets/401_images/401.gif",
	"./404_images/404.png": "./src/assets/404_images/404.png",
	"./404_images/404_cloud.png": "./src/assets/404_images/404_cloud.png",
	"./DataEase-black.png": "./src/assets/DataEase-black.png",
	"./DataEase-color.png": "./src/assets/DataEase-color.png",
	"./DataEase-white.png": "./src/assets/DataEase-white.png",
	"./FileType.png": "./src/assets/FileType.png",
	"./None.png": "./src/assets/None.png",
	"./None_Select.png": "./src/assets/None_Select.png",
	"./None_Select_ds.png": "./src/assets/None_Select_ds.png",
	"./avatar.jpeg": "./src/assets/avatar.jpeg",
	"./banner.png": "./src/assets/banner.png",
	"./datasource/StarRocks.jpg": "./src/assets/datasource/StarRocks.jpg",
	"./datasource/TiDB.jpg": "./src/assets/datasource/TiDB.jpg",
	"./datasource/api.jpg": "./src/assets/datasource/api.jpg",
	"./datasource/ck.jpg": "./src/assets/datasource/ck.jpg",
	"./datasource/db2.jpg": "./src/assets/datasource/db2.jpg",
	"./datasource/ds_doris.jpg": "./src/assets/datasource/ds_doris.jpg",
	"./datasource/es.jpg": "./src/assets/datasource/es.jpg",
	"./datasource/hive.jpg": "./src/assets/datasource/hive.jpg",
	"./datasource/impala.jpg": "./src/assets/datasource/impala.jpg",
	"./datasource/mariadb.jpg": "./src/assets/datasource/mariadb.jpg",
	"./datasource/mongo.jpg": "./src/assets/datasource/mongo.jpg",
	"./datasource/mysql.jpg": "./src/assets/datasource/mysql.jpg",
	"./datasource/oracle.jpg": "./src/assets/datasource/oracle.jpg",
	"./datasource/pg.jpg": "./src/assets/datasource/pg.jpg",
	"./datasource/redshift.jpg": "./src/assets/datasource/redshift.jpg",
	"./datasource/sqlServer.jpg": "./src/assets/datasource/sqlServer.jpg",
	"./deV.png": "./src/assets/deV.png",
	"./dingding01.png": "./src/assets/dingding01.png",
	"./error.png": "./src/assets/error.png",
	"./fill_radio.png": "./src/assets/fill_radio.png",
	"./icon_nopicture_filled.png": "./src/assets/icon_nopicture_filled.png",
	"./lark.png": "./src/assets/lark.png",
	"./license_header.png": "./src/assets/license_header.png",
	"./login-desc.png": "./src/assets/login-desc.png",
	"./nothing.png": "./src/assets/nothing.png",
	"./qrcode.png": "./src/assets/qrcode.png",
	"./template.png": "./src/assets/template.png",
	"./theme-custom.png": "./src/assets/theme-custom.png",
	"./theme-dark.png": "./src/assets/theme-dark.png",
	"./theme-default.png": "./src/assets/theme-default.png",
	"./wecom.png": "./src/assets/wecom.png",
	"./wizard_main_bg.png": "./src/assets/wizard_main_bg.png",
	"./wizard_video1.png": "./src/assets/wizard_video1.png",
	"./wizard_video2.png": "./src/assets/wizard_video2.png",
	"./wizard_video3.png": "./src/assets/wizard_video3.png",
	"./wizard_wechat-group.png": "./src/assets/wizard_wechat-group.png",
	"./wizard_wechat-official.jpeg": "./src/assets/wizard_wechat-official.jpeg",
	"./wizard_wechat-train.png": "./src/assets/wizard_wechat-train.png",
	"./xianshiqi-2.png": "./src/assets/xianshiqi-2.png",
	"./xianshiqi.png": "./src/assets/xianshiqi.png"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./src/assets sync recursive ^\\.\\/.*$";